// extracted by mini-css-extract-plugin
module.exports =  {"text":"_0d624b9a27--text--rcD8R","title":"_0d624b9a27--title--V60zM","link":"_0d624b9a27--link--VAFdQ"};